
        import '/home/builduser/work/575538235ca6a4de/santa-editor/packages/addPreset/previewDrag/thumbnailDragBox.scss.css.virtualfile';
        module.exports = {"htmlThumbnailDragBox":"_htmlThumbnailDragBox_pf8vv_7"};